module.exports = __webpack_public_path__ + "img/search.174272f3.svg";